import {
  extractDatePickerStyleForAndroid,
  extractTextForAndroid,
  extractTextForAndroid_Onboarding,
  serviceCategoriesTexts,
} from '../Utils/StringFilesConfiguration';
import ExportFileManger from './ExportFileManger';
import { getFlowCode } from '../Utils/GeneralUtills';
import { getStringXMLName, onboardingImagesNames } from '../../utils/DictionaryManagementUtils';

const android_dir = 'android/';
const mdpi_dir = 'mdpi/';
const hdpi_dir = 'hdpi/';
const xhdpi_dir = 'xhdpi/';
const xxhdpi_dir = 'xxhdpi/';
const xxxhdpi_dir = 'xxxhdpi/';

const snapshot_and_enable_kbd = 0;
const snapshot_and_select_kbd = 1;
const snapshot_and_menu = 3;
const snapshot_and_bank_or_stickers = 6;
const snapshot_and_phone_image = 7;

export default function AndroidFileManger(exportHandler, snapshotsOnboarding) {
  ExportFileManger.call(this, exportHandler, snapshotsOnboarding, true);

  this.exportStrings = async (configurations) => {
    const promises = configurations.services.screens_ordering
      .filter((serviceKey) => configurations.services[serviceKey].selected)
      .map((serviceKey) => {
        const service = configurations.services[serviceKey];
        const flowCode = getFlowCode(service);
        return this.exportHandler.exportXML(
          serviceCategoriesTexts[service.sub_category](configurations, service, flowCode),
          `${this.getBaseDirectory()}${this.getServicesDirectory()}${getStringXMLName(flowCode)}`,
        );
      });
    await Promise.all(promises);
    await this.exportHandler.exportXML(extractTextForAndroid(configurations), `${this.getBaseDirectory()}strings.xml`);
    await this.exportHandler.exportXML(extractDatePickerStyleForAndroid(configurations), `${this.getBaseDirectory()}date-picker-style.xml`);
  };

  this.exportOnboardingString = async (configurations) => {
    await this
      .exportHandler.exportXML(extractTextForAndroid_Onboarding(configurations), `${this.getBaseDirectory()}${this.getOnboardingDirectory()}strings.xml`);
  };

  this.exportOnboardingIcons = async (onboarding) => {
    const exportImagesList = [
      { name: onboardingImagesNames.ic_onboarding_intro, file: onboarding.announcement.kbd_announcement_icon },
      { name: onboardingImagesNames.ic_activation_success, file: onboarding.instructions.kbd_success_icon },
      { name: onboardingImagesNames.ic_ios_come_back, file: onboarding.instructions.kbd_come_back_icon },
      { name: onboardingImagesNames.ic_onboarding_typing_experience, file: { fUri: await this.handleSnapshots(snapshot_and_phone_image) } },
      { name: onboardingImagesNames.ic_onboarding_services, file: { fUri: await this.handleSnapshots(snapshot_and_menu) } },
      { name: onboardingImagesNames.ic_android_enable_keyboard, file: { fUri: await this.handleSnapshots(snapshot_and_enable_kbd) } },
      { name: onboardingImagesNames.ic_android_select_keyboard, file: { fUri: await this.handleSnapshots(snapshot_and_select_kbd) } },
      { name: onboardingImagesNames.ic_onboarding_security, file: { fUri: await this.handleSnapshots(snapshot_and_bank_or_stickers) } },
      { name: onboardingImagesNames.ic_onboarding_media, file: { fUri: await this.handleSnapshots(snapshot_and_bank_or_stickers) } },
    ];
    await this.exportIcons(exportImagesList, true);
  };

  this.deviceResizeImages = (exportImages) => {
    const exportImagesResize = [];
    exportImages.forEach(({ name, img }) => {
      exportImagesResize.push(this.resizeImage(img, `${mdpi_dir}${name}`, 0.25));
      exportImagesResize.push(this.resizeImage(img, `${hdpi_dir}${name}`, 0.3));
      exportImagesResize.push(this.resizeImage(img, `${xhdpi_dir}${name}`, 0.5));
      exportImagesResize.push(this.resizeImage(img, `${xxhdpi_dir}${name}`, 0.75));
      exportImagesResize.push(this.resizeImage(img, `${xxxhdpi_dir}${name}`, 1));
    });
    return exportImagesResize;
  };

  this.getBaseDirectory = () => android_dir;
}
